import React, { useRef } from "react";
import useIncidentBanner from "../../hooks/useIncidentBanner";
import useBannerOffset from "../../hooks/useBannerOffset";
import IncidentBanner from "./IncidentBanner";

// Mounted outside withADB2CAuth (see src/index.jsx) so the banner is visible
// before login too. useBannerOffset writes to document.body and .navbar-vertical
// directly, so it works from the root just as well as from a layout.
//
// The language is handled by react-i18next inside IncidentBanner: useTranslation
// re-renders on languageChanged, so the banner follows the user's language once
// initLanguage() has resolved it, without this component tracking it.
const IncidentBannerHost = () => {
  const { visible, close } = useIncidentBanner();
  const bannerRef = useRef();
  useBannerOffset(bannerRef, visible);

  if (!visible) return null;

  return <IncidentBanner ref={bannerRef} onClose={close} />;
};

export default IncidentBannerHost;
